import { selector } from 'recoil';

import flightPathState, { appointments, focusedSetAppointment } from '../atoms/flightPath';

export const loader = selector({
  key: 'loader',
  get: ({ get }) => {
    const flightPath = get(flightPathState);
    return flightPath.isLoading;
  },
  set: ({ set, get }, newValue) => set(flightPathState, { ...get(flightPathState), isLoading: newValue })
});

export const allTreatments = selector({
  key: 'treatment',
  get: ({ get }) => {
    const flightPath = get(flightPathState);
    return flightPath.treatments;
  },
  set: ({ set, get }, newValue) => set(flightPathState, { ...get(flightPathState), treatments: newValue })
});

export const pastAppointments = selector({
  key: 'pastAppointments',
  get: ({ get }) => {
    const list = get(appointments);
    return list.pastAppointments;
  },
  set: ({ set, get }, newValue) => set(appointments, { ...get(appointments), pastAppointments: newValue })
});

export const upcomingAppointments = selector({
  key: 'upcomingAppointments',
  get: ({ get }) => {
    const list = get(appointments);
    return list.upcomingAppointments;
  },
  set: ({ set, get }, newValue) => set(appointments, { ...get(appointments), upcomingAppointments: newValue })
});

export const focusedAlignerAppointment = selector({
  key: 'focusedAlignerAppointment',
  get: ({ get }) => {
    const key = get(focusedSetAppointment);
    return key.selectedAppointmentCardId;
  },
  set: ({ set, get }, newValue) => set(focusedSetAppointment,
    { ...get(focusedSetAppointment), selectedAppointmentCardId: newValue })
});
